// config
const resolveDefaultOrigin = () => {
  if (typeof window !== "undefined" && window.location) {
    const { hostname, port, protocol, origin } = window.location;
    if (hostname === "localhost" && port === "3000") {
      return "https://localhost:8080";
    }
    if (hostname === "127.0.0.1" && port === "3000") {
      return "https://127.0.0.1:8080";
    }
    if (origin) {
      return origin;
    }
    return `${protocol}//${hostname}`;
  }
  return "https://localhost:8080";
};

const defaultBaseSoundURL = resolveDefaultOrigin();
const defaultBaseURL = `${defaultBaseSoundURL}/api`;

const fromRuntime =
  typeof window !== "undefined" ? window.__APP_CONFIG__ : undefined;
export const baseURL =
  fromRuntime?.REACT_APP_BASE_URL ??
  process.env.REACT_APP_BASE_URL ??
  defaultBaseURL;

const explicitSoundURL =
  fromRuntime?.REACT_APP_BASE_SOUND_URL ??
  process.env.REACT_APP_BASE_SOUND_URL;

/** Если sound URL не задан — берём origin API (baseURL без /api), а не origin страницы. */
export const baseSoundURL =
  explicitSoundURL ??
  (baseURL.replace(/\/?api\/?$/, "") || defaultBaseSoundURL);
